// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"175edd8293811b185e56","655":"f729ae678ea22720a999"}[chunkId] + ".js";
};